<template>
  <a-layout id="app" class="layout">
      <loading :show="isLoading" :label="'loading'" />
      <Main-Header />
      <a-layout-content :style="{padding: '0 50px', marginTop: '100px'}">
        <div :style="{ background: '#fff', padding: '24px', minHeight: '100vh' }">
          <router-view/>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        TELAS ©{{ new Date().getFullYear() }}
      </a-layout-footer>
  </a-layout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import loading from 'vue-full-loading';
import MainHeader from '@/components/Header.vue';

export default {
  components: {
    MainHeader,
    loading,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('common', {
      isLoading: state => state.loading,
    }),
    ...mapGetters('dashboard', {
      userDetails: 'getUserProfileDetails',
    }),
  },
  created() {
    this.$nextTick(function validateCallback() {
      this.validateToken();
    });
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'user/TOKENVALIDATION') {
        if (Object.entries(state.user.userDetails).length === 0
        && this.userDetails.constructor === Object) {
          // eslint-disable-next-line no-unused-vars
          this.$router.push({ path: '/' }).catch((err) => {});
        }
      }
    });
  },
  mounted() {
  },
  methods: {
    ...mapActions('user', {
      validateToken: 'validateToken',
    }),
  },
  watch: {

  },
};
</script>
<style>
</style>
